import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET } from "./apiRoutes";

const mutateDeleteBudget = async ({
  communityId,
  budgetId,
}: {
  communityId: string;
  budgetId: string;
}) => {
  return await axiosAuth.delete(
    `${BUDGET(communityId)}/${budgetId}`
  );
};

const useDeleteBudgetMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: string;
      budgetId: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteBudget,
    ...queryParams,
  });

export default useDeleteBudgetMutation;